var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-22-37a1,1,0,0,1,1,1v12a1,1,0,0,1-1,1H-33.764a.994.994,0,0,1-.894-.553l-4-6a1,1,0,0,1,0-.894l4-6A.994.994,0,0,1-33.764-37H-22m0-1H-33.764a2,2,0,0,0-1.789,1.106l-4,6a2.006,2.006,0,0,0,0,1.79l4,6A2,2,0,0,0-33.764-22H-22a2,2,0,0,0,2-2V-36a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.293-30l3.147-3.146a.5.5,0,0,0,0-.708.5.5,0,0,0-.708,0L-29-30.707l-3.146-3.147a.5.5,0,0,0-.708,0,.5.5,0,0,0,0,.708L-29.707-30l-3.147,3.146a.5.5,0,0,0,0,.708A.5.5,0,0,0-32.5-26a.5.5,0,0,0,.354-.146L-29-29.293l3.146,3.147A.5.5,0,0,0-25.5-26a.5.5,0,0,0,.354-.146.5.5,0,0,0,0-.708Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/Backspace.f1641876da1df695ecdec3427f75264e.svg";
export { ForwardRef as ReactComponent };